import { render, staticRenderFns } from "./studyDelete.vue?vue&type=template&id=66938f38&"
import script from "./studyDelete.vue?vue&type=script&lang=js&"
export * from "./studyDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports